import { Prop } from '@typegoose/typegoose'

// Enum must be declared before the class that uses it
export enum PasswordlessDeliveryTypeEnum {
  email = 'email',
  sms = 'sms',
}

export class PasswordlessAuth {
  @Prop({ type: String })
  requestId: string

  @Prop({ type: String })
  code: string

  @Prop({ type: Date })
  expiry: Date

  @Prop({ type: String })
  deliveryType: PasswordlessDeliveryTypeEnum

  @Prop({ type: Number })
  attempts: number
}
